// extracted by mini-css-extract-plugin
export default {"list-container":"chat-list_list-container__P6ike","container":"chat-list_container__QPA1C","hint":"chat-list_hint__V-fDb","hint-text":"chat-list_hint-text__h3jWu"};